<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"><b>A ROYAL NAVY COLD WAR BUCCANEER PILOT</b></a></h1><a id="page_iii">
<p class="titlea">FLYING THE FAMOUS MARITIME STRIKE AIRCRAFT</p>
<p class="author">STEVE KERSHAW</p>
<div class="image_containerf">
<img alt="images" src="images/f00iii-01.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?66f91281